import isKeyable from "./component-library478.mjs";
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
export {
  getMapData as default
};
